(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fortryd_koeb"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.getElementById('fortryd');
  var form = document.getElementById('fortryd-form');
  if (!wrap || !form) return;

  var KEY      = wrap.dataset.klaviyoKey || '';
  var REVISION = wrap.dataset.klaviyoRevision || '2024-10-15';
  var METRIC   = wrap.dataset.klaviyoMetric || 'Fortrydelse anmodet';
  var LOCALE   = wrap.dataset.locale || 'da';

  form.addEventListener('submit', function () {
    try {
      var now = new Date();
      var tid;
      try {
        tid = now.toLocaleString(LOCALE, { dateStyle: 'long', timeStyle: 'short' });
      } catch (e) {
        tid = now.toISOString();
      }

      var tidEl = document.getElementById('fortryd-tid');
      if (tidEl) tidEl.value = tid;

      if (!KEY) return;

      var get = function (id) {
        var el = document.getElementById(id);
        return el ? el.value : '';
      };

      var email = get('fortryd-email');
      if (!email) return;

      var payload = {
        data: {
          type: 'event',
          attributes: {
            time: now.toISOString(),
            properties: {
              'Navn': get('fortryd-navn'),
              'Ordrenummer': get('fortryd-ordre'),
              'Varer der ønskes fortrudt': get('fortryd-varer'),
              'Indsendt': tid,
              'Sprog': LOCALE
            },
            metric:  { data: { type: 'metric',  attributes: { name: METRIC } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(KEY), {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify(payload)
      });
    } catch (e) {
      /* Fejler stille. Butikken får stadig anmodningen via Shopify-mailen. */
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
